import React, { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import greenDot from "../../assets/images/green-dot.gif";
import danger from "../../assets/images/yellow-gold.gif";
import { getCompletedCourseList, getCoursesByGroup } from "../../services/api/course.service";
import { getUserPoints } from "../../services/api/userInteraction";
import { APP_URL } from "../../util/constants/APP_URL";
import { NumberTextFormatter } from "../../util/methods/text";

import Slider from "react-slick";
import { ModalCourses } from "../../components/modalCourses";
import { ModalGroups } from "../../components/modalGroups";
import { ModalPolitics } from "../../components/modalPolitics";
import { ModalPoliticsDowndload } from "../../components/modalPoliticsDownload";
import { IGroupData } from "../../models/Group";
import { getPoliticStatus } from "../../services/api/politic.service";

import buttonPoints from "../../assets/images/btn_points.svg";
import iconGroup from "../../assets/images/icon/icon-group.svg";
import { ModalLogout } from "../../components/modalLogout";
import { ModalPoints } from "../../components/modalPoints";

const Dashboard = () => {

    const navigate = useNavigate()
    const sliderRef = useRef<any>(null)

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const [currentSlide, setCurrentSlide] = useState<number>(1)
    const [currentGroup, setCurrentGroup] = useState<IGroupData | null>(null);

    const [courses, setCourses] = useState<any[]>([])
    const [points, setPoints] = useState<string>('00')
    const [coursesCompleted, setCoursesCompleted] = useState<string>('00')

    const [showPoliticModal, setShowPoliticModal] = useState<boolean>(false);
    const [showPoliticDownloadModal, setShowPoliticDownloadModal] = useState<boolean>(false);
    const [showGroupModal, setShowGroupModal] = useState<boolean>(false);
    
    const [showCourseModal, setShowCourseModal] = useState<boolean>(false);
    const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
    const [showModalPoints, setShowModalPoints] = useState<boolean>(false);

    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1800,
        draggable: true
      };


    useEffect(() => {
        const handleResize = () => {
          setWidth(window.innerWidth);
          setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        getPoints();
        getPoliticData();
    }, [])

    const getCalcScale = () => {
        const fraction = (width - 170) / 480;

        const heightIsShort = height <= 500 ? '1.6' : '2'
        const isFractionMoreTwo = fraction > 2 ? heightIsShort : fraction.toString();

        return fraction < 1 ? '1' : isFractionMoreTwo;
    }

    const getCourseList = async (group_id: string) => {
        await getCoursesByGroup(group_id)
            .then(result => {
                if (result) {
                    const { data } = result.response

                    localStorage.setItem("asg_courses_list", JSON.stringify(data))
                    setCourses([...data])
                 }
            })
    }

    const getPoints = async () => {
        await getUserPoints()
            .then((result: any) => {
                if (result.status) {
                    setPoints(result.points)
                }
            })
    }

    const completedCourses = async (group: IGroupData) => {
        getCompletedCourseList(group.id).then((result) => {
            if (result) {
                const courses = result.data;
                setCoursesCompleted(courses.length.toString().padStart(2, '0'));
            }
        });
    }

    const gotToCourse = async (course: any) => {
        localStorage.setItem("asg_course", JSON.stringify(course));
        navigate(APP_URL.QUIZ.COURSES + course.path);
    }

    const handleClosePoliticModal = async() => {
        setShowPoliticModal(false);
        if (!currentGroup) setShowGroupModal(true);
    }

    const handleClosePoliticDownloadModal = async() => {
        setShowPoliticDownloadModal(false);
    }

    const handleCloseCourseModal = () => {
        setShowCourseModal(false);
    }

    const handleSelectGroup = (group: IGroupData) => {
        getCourseList(group.id);
        setShowGroupModal(false);
        setCurrentGroup(group);
        completedCourses(group);
    }

    const onCloseGroupModal = () => {
        setShowGroupModal(false);
    }

    const getPoliticData = async () => {
        await getPoliticStatus()
            .then(result => {
                if (result) {
                    const { data } = result.response;

                    if (data.total > data.visited) setShowPoliticModal(true);
                    else setShowGroupModal(true)
                }
            })
    }

    const disponibleCourses = () => {
        const coursesDisponibles = courses.length;
        const completedCourses = Number(coursesCompleted);

        const difference = coursesDisponibles - completedCourses;

        return completedCourses === 0 ? 0 : (difference === 0 ? coursesDisponibles : (completedCourses + 1))
    }

    const previousSlide = () => {
        if (currentSlide <= 1) return;
        setCurrentSlide(currentSlide - 1)
    }

    const nextSlide = () => {
        const currentLenghtGroups = courses.length;
        if (currentSlide >= currentLenghtGroups) return;
        setCurrentSlide(currentSlide + 1)
    }

    const ArrowLeft = (props: any) => {
        const { onClick, currentSlide } = props
        const isVisible = currentSlide !== 0
        return (
              isVisible ? 
                <button type='button' onClick={onClick} className={`slick-prev z-[450!important] before:!hidden arrow-slider arrow-left`}></button> : 
                <></>
        )
      }
      
      const ArrowRight = (props: any) => {
        const { onClick, currentSlide, count } = props
        const isVisible = currentSlide < count - 1
        return (
              isVisible ? 
                <button type='button' onClick={onClick} className={`slick-next before:!hidden arrow-slider arrow-right`}></button> : 
                <></>
        )
      }

      const showLogout = () => {
        setShowLogoutModal(!showLogoutModal);
      }

      const showPointsTable = () => {
        setShowModalPoints(!showModalPoints);
      }

    return (
        <div className="width-full height-full">
            {
                (!showGroupModal && !showPoliticModal && !showPoliticDownloadModal) &&
                (
                    <div className="dashboard width-full height-full">
                        <div className="box" style={{ scale: getCalcScale() }}>
                            <div>
                                <div className="ft-EricssonGA628 text-light-green absolute title-box">
                                    CURSOS DESBLOQUEADOS
                                </div>
                                <div className="ft-EricssonGA628 text-light-green absolute count-box">
                                    {/* {NumberTextFormatter(disponibleCourses())} */}
                                    {coursesCompleted}
                                </div>
                                <div>
                                    <div className={`ft-EricssonGA628 text-light-black absolute money-box-pointer ${points.length == 2 ? 'normal' : points.length  >= 4 ? 'very-large' : 'large'} text-yellow`}>
                                        { points }
                                    </div>
                                    <div className="ft-EricssonGA628 text-light-black absolute money-box">
                                        MONEDAS ACUMULADAS
                                    </div>
                                    <div className="option-points" onClick={showPointsTable}>
                                        <img src={buttonPoints} />
                                    </div>
                                </div>
                            </div>
                            <div className="options-box">
                                <div className="ft-EricssonGA628 text-light-green absolute">
                                    <div className="title">
                                        CURSOS DISPONIBLES
                                    </div>
                                    <div className="points">
                                        {NumberTextFormatter(courses.length)}
                                    </div>
                                </div>
                                <div className="ft-EricssonGA628 text-white absolute">
                                <div className="title gap-1">
                                        <label>CURSOS COMPLETADOS</label>
                                        <img src={danger} alt="danger" style={{ width: '12px', height: '10px' }}></img>
                                    </div>
                                    <div className="points text-orange">
                                        {coursesCompleted}
                                    </div>
                                </div>
                                <div className="ft-EricssonGA628 text-white absolute">
                                    <div className="title">
                                        POSICIÓN GLOBAL
                                    </div>
                                    <div className="points">
                                        00
                                    </div>
                                </div>
                                <div className="ft-EricssonGA628 text-white absolute">
                                    <div className="title">
                                        CERTIFICADOS LISTOS
                                    </div>
                                    <div className="points">
                                        {coursesCompleted}
                                    </div>
                                    <div onClick={() => setShowCourseModal(true)}>
                                    </div>
                                </div>
                                <div className="ft-EricssonGA628 text-white absolute">
                                    <div role="button" className="title pointer" onClick={() => setShowPoliticModal(true) }>
                                        CONSULTAR DOCUMENTOS ASG
                                    </div>
                                    <div className="points pointer" onClick={() => setShowPoliticDownloadModal(true)}></div>
                                </div>
                                <div className="dot-button absolute">
                                    <img src={greenDot} alt="dot"></img>
                                </div>
                            </div>
                            <div className="points-box-titles ft-EricssonGA628">
                                <label>VALOR MONEDAS</label>
                                <label>VALOR ESPECIALES</label>
                            </div>
                            <div className="points-box ft-EricssonGA628">
                                <label>10</label>
                                <label>20</label>
                                <label>30</label>
                                <label>40</label>
                                <label>50</label>
                                <label>100</label>
                                <label>200</label>
                                <label>x2</label>
                                <label>x4</label>
                            </div>
                            <div className="courses-box ft-EricssonGA628">
                                <div className="title">
                                    <label>CURSOS DISPONIBLES</label>
                                </div>
                                <div className="courses-content">
                                    <div className="slider-container">
                                        {
                                            courses.length > 0 &&
                                            <Slider 
                                                ref={sliderRef}  
                                                {...settings}
                                                prevArrow={
                                                    <ArrowLeft
                                                        onClick={previousSlide}
                                                        count={courses.length}
                                                        currentSlide={currentSlide}
                                                    />
                                                }
                                                nextArrow={
                                                    <ArrowRight
                                                        onClick={nextSlide}
                                                        count={courses.length}
                                                        currentSlide={currentSlide}
                                                    />
                                                }>
                                                {
                                                    courses.map(course => {
                                                        return (
                                                            <div key={course.id} className="course-card">
                                                                <button onClick={() => gotToCourse(course)} className="course_image">
                                                                    <img src={course.image} alt="course" />
                                                                </button>
                                                                {/* <button onClick={() => gotToCourse(course)} key={course.id} className="description">
                                                                    <div className="name ft-EricssonGA628">{course.name} : APRUEBA CON {course.score}% DE ACIERTOS</div>
                                                                    <div className="bonus ft-EricssonGA628">BONUS: {course.bonus} MONEDAS</div>
                                                                </button> */}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Slider>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                !!currentGroup &&
                                <div onClick={() => setShowGroupModal(true)}  className="flex justify-content-center button-submit flex-column align-items-center gap-3 button-groups">
                                    <button className="btn-group-modal ft-EricssonGA628">
                                        <p> { currentGroup.name }</p>
                                        <img src={iconGroup} />
                                    </button>
                                </div>
                            }
                            <button onClick={showLogout} className="ft-EricssonGA628 button-exit">
                                X
                            </button>
                        </div>
                    </div>
                )
            }
            {
                showCourseModal && currentGroup &&
                <ModalCourses onClose={handleCloseCourseModal} group={currentGroup} />
            }
            {
                showPoliticModal &&
                <ModalPolitics onClose={handleClosePoliticModal} />
            }
            {
                showPoliticDownloadModal &&
                <ModalPoliticsDowndload onClose={handleClosePoliticDownloadModal} />
            }
            {
                showLogoutModal &&
                <ModalLogout onClose={showLogout} />
            }
            {
                showModalPoints &&
                <ModalPoints onClose={showPointsTable} />
            }
            {
                showGroupModal &&
                <ModalGroups onHandleAccept={handleSelectGroup} onClose={onCloseGroupModal} current={currentGroup} />
            }
        </div>
    )
}

export default Dashboard